// Shared by the browser queue and server partition/validation boundary.
export const USER_WORKSPACE_STATE_KEYS = Object.freeze(['copied-steps', 'aiHistory']);
